import {useEffect} from 'react'
import {useSearchParams} from 'react-router-dom'

import useFetch from 'shared/model/useFetch'
import {
	ROLE_EXTERNAL_ADMIN,
	ROLE_FIELD_MANAGER,
	ROLE_TIMER_MANAGER,
	ROLE_COMPETITION_MANAGER,
} from 'shared/constant/lookup/role'
import useRoleCookie from 'shared/model/useRoleCookie'
import getApiRolePath from 'shared/utils/getApiRolePath'

const useGetEventList = () => {
	const [fetchResult, fetchRequest, isLoading] = useFetch()
	const [searchParams] = useSearchParams()
	const [userRole] = useRoleCookie()

	const page = searchParams.get('page')
	const search = searchParams.get('search')

	const isManagerRole =
		userRole === ROLE_FIELD_MANAGER ||
		userRole === ROLE_TIMER_MANAGER ||
		userRole === ROLE_COMPETITION_MANAGER

	useEffect(() => {
		const rolePath = getApiRolePath(userRole)
		let path = `/${rolePath}/event/list?page=${page}`

		if (search) path += `&search=${search}`
		if (isManagerRole && search) {
			path += `&search_globally=true`
		}
		fetchRequest('GET', path)
	}, [page, search])

	return [fetchResult, isLoading]
}

export default useGetEventList
